export default (props = {}) => <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg"{...props}>
<g id="tips/check_warning">
<path id="Subtract" d="M16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3ZM14.4033 20.3906V23.584H17.5967V20.3906H14.4033ZM14.4033 8.41602V18.7939H17.5967V8.41602H14.4033Z"/>
</g>
</svg>
